import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

const StepClienteForm = ({
  modoEdicion,
  nuevaEmpresa,
  setNuevaEmpresa,
  nuevoTipo,
  setNuevoTipo,
  nuevoRut,
  nuevaRazon,
  setNuevaRazon,
  nuevoAlias,
  setNuevoAlias,
  nuevoFanta,
  setNuevoFanta,
  giro,
  setGiro,
  empresas,
  tipos,
  mostrarError,
  handleCampoTocado,
  handleRutChange,
  handleRutBlur,
  onNext,
}) => {
  return (
    <div className="card">
      <h6>{modoEdicion ? "Modifique los datos del cliente" : "Ingrese los datos del cliente a registrar"}</h6>
      <div className="p-fluid formgrid grid">
        {/* Empresa */}
        <div className="field col-12 md:col-3 mt-2">
          <label style={{ color: "red" }}>Empresa *</label>
          <Dropdown
            id="Empresa"
            value={nuevaEmpresa}
            onChange={(e) => {
              setNuevaEmpresa(e.value);
              handleCampoTocado("empresa");
            }}
            onBlur={() => handleCampoTocado("empresa")}
            options={empresas}
            optionLabel="nombre"
            optionValue="id"
            placeholder="Seleccione Empresa"
            className={`p-inputtext-sm ${mostrarError("empresa") ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: mostrarError("empresa") ? "#dc3545" : "#ced4da",
            }}
          />
          {mostrarError("empresa") && <small className="p-error">Este campo es obligatorio</small>}
        </div>

        {/* Rut */}
        <div className="field col-12 md:col-3 mt-2">
          <label style={{ color: "red" }}>Rut *</label>
          <InputText
            id="rut"
            type="text"
            value={nuevoRut || ""}
            onChange={(e) => {
              handleRutChange(e);
              handleCampoTocado("rut");
            }}
            onBlur={() => {
              handleRutBlur();
              handleCampoTocado("rut");
            }}
            maxLength={12}
            className={`p-inputtext-sm ${mostrarError("rut") ? "p-invalid" : ""}`}
            style={{
              borderColor: mostrarError("rut") ? "#dc3545" : "#ced4da",
              borderRadius: "4px",
            }}
            placeholder="Ingrese RUT"
            readOnly={modoEdicion}
          />
          {mostrarError("rut") && (
            <small className="p-error">Este campo es obligatorio y debe ser válido</small>
          )}
        </div>

        {/* Razón Social / Nombre */}
        <div className="field col-12 md:col-3 mt-2">
          <label style={{ color: "red" }}>Razón Social / Nombre *</label>
          <InputText
            id="razonSocial"
            type="text"
            value={nuevaRazon || ""}
            onChange={(e) => {
              setNuevaRazon(e.target.value.toUpperCase());
              handleCampoTocado("razonSocial");
            }}
            onBlur={() => handleCampoTocado("razonSocial")}
            maxLength={90}
            className={`p-inputtext-sm ${mostrarError("razonSocial") ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: mostrarError("razonSocial") ? "#dc3545" : "#ced4da",
            }}
            placeholder="Ingrese razón social"
          />
          {mostrarError("razonSocial") && <small className="p-error">Este campo es obligatorio</small>}
        </div>

        {/* Giro */}
        <div className="field col-12 md:col-3 mt-2">
          <label style={{ color: "red" }}>Giro *</label>
          <InputText
            id="giro"
            type="text"
            value={giro || ""}
            onChange={(e) => {
              setGiro(e.target.value.toUpperCase());
              handleCampoTocado("giro");
            }}
            onBlur={() => handleCampoTocado("giro")}
            maxLength={45}
            className={`p-inputtext-sm ${mostrarError("giro") ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: mostrarError("giro") ? "#dc3545" : "#ced4da",
            }}
            placeholder="Ingrese giro"
          />
          {mostrarError("giro") && <small className="p-error">Este campo es obligatorio</small>}
        </div>

        {/* Alias */}
        <div className="field col-12 md:col-3 mt-2">
          <label style={{ color: "red" }}>Alias *</label>
          <InputText
            id="alias"
            type="text"
            value={nuevoAlias || ""}
            onChange={(e) => {
              setNuevoAlias(e.target.value.toUpperCase());
              handleCampoTocado("alias");
            }}
            onBlur={() => handleCampoTocado("alias")}
            maxLength={90}
            className={`p-inputtext-sm ${mostrarError("alias") ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: mostrarError("alias") ? "#dc3545" : "#ced4da",
            }}
            placeholder="Ingrese alias"
          />
          {mostrarError("alias") && <small className="p-error">Este campo es obligatorio</small>}
        </div>

        {/* Tipo de Cliente */}
        <div className="field col-12 md:col-3 mt-2">
          <label style={{ color: "red" }}>Tipo de Cliente *</label>
          <Dropdown
            id="tipocliente"
            value={nuevoTipo}
            onChange={(e) => {
              setNuevoTipo(e.value);
              handleCampoTocado("tipoCliente");
            }}
            onBlur={() => handleCampoTocado("tipoCliente")}
            options={tipos}
            optionLabel="nombre"
            optionValue="id"
            placeholder="Seleccione una opción"
            className={`p-inputtext-sm ${mostrarError("tipoCliente") ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: mostrarError("tipoCliente") ? "#dc3545" : "#ced4da",
            }}
            filter
          />
          {mostrarError("tipoCliente") && <small className="p-error">Este campo es obligatorio</small>}
        </div>

        {/* Nombre Fantasía */}
        <div className="field col-12 md:col-6 mt-2">
          <label style={{ color: "red" }}>Nombre Fantasía *</label>
          <InputText
            id="nombreFantasia"
            type="text"
            value={nuevoFanta || ""}
            onChange={(e) => {
              setNuevoFanta(e.target.value.toUpperCase());
              handleCampoTocado("nombreFantasia");
            }}
            onBlur={() => handleCampoTocado("nombreFantasia")}
            maxLength={90}
            className={`p-inputtext-sm ${mostrarError("nombreFantasia") ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: mostrarError("nombreFantasia") ? "#dc3545" : "#ced4da",
            }}
            placeholder="Ingrese nombre de fantasía"
          />
          {mostrarError("nombreFantasia") && <small className="p-error">Este campo es obligatorio</small>}
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button label="" rounded outlined icon="pi pi-arrow-right" iconPos="right" onClick={onNext} />
      </div>
    </div>
  );
};

export default StepClienteForm;
